import { FormControl, Grid, MenuItem, Select, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import ComplaintsHierarchyFilters from "./ComplaintsHierarchyFilters";

const FilterFieldLabel = ({ htmlFor, children }) => (
  <Typography
    component="label"
    variant="body2"
    htmlFor={htmlFor}
    sx={{ fontWeight: 600, color: "text.secondary", display: "block" }}
  >
    {children}
  </Typography>
);

FilterFieldLabel.propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.node,
};

/** Pending-style filters + APMS Status / Escalated To. */
export default function APMSComplaintsFilters({
  statusFilter,
  onStatusFilterChange,
  escalationFilter,
  onEscalationFilterChange,
  ...hierarchyProps
}) {
  const trailingFilters = (
    <>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor={`${hierarchyProps.idPrefix}-status`}>
            Status
          </FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id={`${hierarchyProps.idPrefix}-status`}
              value={statusFilter}
              onChange={(e) => onStatusFilterChange(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Allocated">Allocated</MenuItem>
              <MenuItem value="Working">Working</MenuItem>
              <MenuItem value="OnHold">OnHold</MenuItem>
              <MenuItem value="Resolved">Resolved</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor={`${hierarchyProps.idPrefix}-escalated`}>
            Escalated To
          </FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id={`${hierarchyProps.idPrefix}-escalated`}
              value={escalationFilter}
              onChange={(e) => onEscalationFilterChange(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="SDO">SDO</MenuItem>
              <MenuItem value="SE">SE</MenuItem>
              <MenuItem value="XEN">XEN</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Grid>
    </>
  );

  return (
    <ComplaintsHierarchyFilters
      {...hierarchyProps}
      trailingFilters={trailingFilters}
    />
  );
}

APMSComplaintsFilters.propTypes = {
  statusFilter: PropTypes.string.isRequired,
  onStatusFilterChange: PropTypes.func.isRequired,
  escalationFilter: PropTypes.string.isRequired,
  onEscalationFilterChange: PropTypes.func.isRequired,
  idPrefix: PropTypes.string,
  showGo: PropTypes.bool,
  dateFrom: PropTypes.string,
  setDateFrom: PropTypes.func.isRequired,
  dateTo: PropTypes.string,
  setDateTo: PropTypes.func.isRequired,
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hierarchy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedCompanyCode: PropTypes.string,
  onChangeCompany: PropTypes.func,
  circleCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeCircle: PropTypes.func,
  filteredCircles: PropTypes.array,
  selectedDivision: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeDivision: PropTypes.func,
  filteredDivisions: PropTypes.array,
  selectedSubDivision: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeSubDivision: PropTypes.func,
  filteredSubDivisions: PropTypes.array,
  onGoClick: PropTypes.func,
  isGoDisabled: PropTypes.bool,
  viewBackdrop: PropTypes.bool,
};
